import {IconProps} from './types';
import * as React from "react";

const Video = ({fill = 'currentColor', className}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    fill="none"
    viewBox="0 0 21 20"
    className={className}
  >
    <path
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 5.833v5.834l5.417-2.917z"
    ></path>
    <path
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.167 2.083h15.866s1.667 0 1.667 1.667v10s0 1.667-1.667 1.667H2.167S.5 15.417.5 13.75v-10s0-1.667 1.667-1.667M16.334 17.917h-12.5"
    ></path>
  </svg>
);

export default Video;
